import React from 'react';
import { default as BaseNewsTable } from '../Table/News/NewsTable';
import InterestUri from '../../../Enum/InterestUri';
import { useGetInterestNews } from '../../../Hook/Interest/FetchTableData/UseGetNews';

const NewsTable: React.FC = () => (
    <BaseNewsTable useHook={useGetInterestNews} section={InterestUri.InterestNews} />
);

export default NewsTable;
